/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
/*  eslint-disable react/prop-types */
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import connect from '../../../utils/connect';

import { useFormikContext } from 'formik';
import { FiltersFormContext } from './FiltersFormContext';

import { Typography, Flex, Select, TreeSelect, Input } from '@app/ui';

import InputTag from './InputTag';
const { SHOW_PARENT } = TreeSelect;

const SmpFiltersRow = () => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext();

    const {
        platformsOptions,
        accTypesOptions,
        mediaTypesOptions,
        collectionsOptions,
        setFormValue,
        hasPremiumCollections,
        MVPoptions,
        isOverridingFilters,
    } = useContext(FiltersFormContext);

    const hasCollabPostsReporting = true;

    const authorshipTypeOptions = useMemo(
        () => [
            {
                value: 'standard',
                label: t('filters.authorshipType.standard'),
            },
            {
                value: 'collaboration',
                label: t('filters.authorshipType.collaboration'),
            },
            {
                value: 'unsupported',
                label: t('filters.authorshipType.unsupported'),
            },
        ],
        [t],
    );

    const get = key =>
        Object.entries(values[key] ?? {})
            .filter(([, value]) => value)
            .map(([key]) => `${key}`);

    const update = key => v => {
        setFieldValue(
            key,
            v.reduce((acc, value) => {
                acc[value] = true;
                return acc;
            }, {}),
            false,
        );
    };

    const ptfOptions = React.useMemo(() => {
        return platformsOptions.map(option => {
            const newNestedOptions =
                option.nested?.map(nestedOption => {
                    return {
                        value: `${option.value}-${nestedOption.value}`,
                        title: nestedOption.label,
                    };
                }) ?? null;

            return {
                value: `${option.value}`,
                title: option.label,
                children: newNestedOptions,
            };
        });
    }, [platformsOptions]);

    const mvpOptions = React.useMemo(() => {
        return MVPoptions.map(option => {
            return {
                value: option.value,
                label: option.name,
            };
        });
    }, [MVPoptions]);

    const dropdownWithSelectAll = (selectAll, hasOptions) => menu => {
        return (
            <>
                {hasOptions && (
                    <div
                        style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                        }}
                        onClick={selectAll}
                    >
                        <Typography.Text style={{ fontWeight: 'bold' }}>
                            {t('filters.selectAll')}
                        </Typography.Text>
                    </div>
                )}
                {menu}
            </>
        );
    };

    return (
        <Flex vertical gap={8} style={{ padding: '16px 0' }}>
            <Flex gap={16} wrap="wrap">
                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-plt-dropdown"
                    >
                        {t('filters.platforms')}
                    </Typography.Text>

                    <TreeSelect
                        treeCheckable
                        showCheckedStrategy={SHOW_PARENT}
                        placeholder={t('filters.selectPlatforms')}
                        treeData={ptfOptions}
                        value={get('platforms')}
                        onChange={update('platforms')}
                        treeNodeFilterProp="title"
                        autoClearSearchValue={false}
                        showSearch
                        allowClear
                        maxTagCount={2}
                        maxTagTextLength={8}
                        maxTagPlaceholder={`...`}
                        style={{
                            maxHeight: '32px',
                            overflow: 'hidden',
                        }}
                        dropdownRender={dropdownWithSelectAll(() => {
                            update('platforms')(
                                ptfOptions.map(({ value }) => value),
                            );
                        }, ptfOptions.length > 0)}
                        disabled={
                            isOverridingFilters || ptfOptions.length === 0
                        }
                    />
                </Flex>

                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-plt-dropdown"
                    >
                        {t('filters.accountTypes')}
                    </Typography.Text>
                    <Select
                        mode="multiple"
                        placeholder={t('filters.selectAccountTypes')}
                        options={accTypesOptions}
                        value={get('accTypes')}
                        onChange={update('accTypes')}
                        optionFilterProp="label"
                        allowClear
                        maxTagCount={1}
                        maxTagPlaceholder={`...`}
                        style={{
                            maxHeight: '32px',
                            overflow: 'hidden',
                        }}
                        autoClearSearchValue={false}
                        dropdownRender={dropdownWithSelectAll(() => {
                            update('accTypes')(
                                accTypesOptions.map(({ value }) => value),
                            );
                        }, accTypesOptions.length > 0)}
                        disabled={
                            isOverridingFilters || accTypesOptions.length === 0
                        }
                    />
                </Flex>

                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-mt-dropdown"
                    >
                        {t('filters.mediaTypes')}
                    </Typography.Text>
                    <Select
                        mode="multiple"
                        placeholder={t('filters.selectMediaTypes')}
                        options={mediaTypesOptions}
                        value={values.mediaTypes}
                        onChange={setFormValue('mediaTypes')}
                        optionFilterProp="label"
                        allowClear
                        maxTagCount={1}
                        maxTagPlaceholder={`...`}
                        style={{
                            maxHeight: '32px',
                            overflow: 'hidden',
                        }}
                        autoClearSearchValue={false}
                        dropdownRender={dropdownWithSelectAll(() => {
                            setFormValue('mediaTypes')(
                                mediaTypesOptions.map(({ value }) => value),
                            );
                        }, mediaTypesOptions.length > 0)}
                        disabled={
                            isOverridingFilters ||
                            mediaTypesOptions.length === 0
                        }
                    />
                </Flex>
            </Flex>
            <Flex gap={16} wrap="wrap">
                {hasPremiumCollections && (
                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text
                            className="-filter-title"
                            data-test="new-c-dropdown"
                        >
                            {t('filters.collections')}
                        </Typography.Text>
                        <Select
                            placeholder={t('filters.selectCollections')}
                            mode="multiple"
                            options={collectionsOptions}
                            value={values.collections}
                            onChange={setFormValue('collections')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={1}
                            maxTagPlaceholder={`...`}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                            }}
                            autoClearSearchValue={false}
                            dropdownRender={dropdownWithSelectAll(() => {
                                setFormValue('collections')(
                                    collectionsOptions.map(
                                        ({ value }) => value,
                                    ),
                                );
                            }, collectionsOptions.length > 0)}
                            disabled={
                                isOverridingFilters ||
                                collectionsOptions.length === 0
                            }
                        />
                    </Flex>
                )}

                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-ht-dropdown"
                    >
                        {t('filters.hashtags')}
                    </Typography.Text>
                    <InputTag
                        value={values.hashtags}
                        onChange={setFormValue('hashtags')}
                        placeholderText={t('filters.enterHashtags')}
                        data-test="new-ht-dropdown"
                        disabled={isOverridingFilters}
                    />
                </Flex>

                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-hd-dropdown"
                    >
                        {t('filters.handles')}
                    </Typography.Text>
                    <InputTag
                        value={values.handles}
                        onChange={setFormValue('handles')}
                        placeholderText={t('filters.enterHandles')}
                        isHandleInput
                        disabled={isOverridingFilters}
                    />
                </Flex>

                <Flex vertical flex={1} gap={4}>
                    <Typography.Text className="-filter-title">
                        {t('filters.caption')}
                    </Typography.Text>
                    <Input
                        value={values.caption ?? ''}
                        onChange={e => setFormValue('caption')(e.target.value)}
                        placeholder={t('filters.enterCaption')}
                        data-test="caption-input"
                        disabled={isOverridingFilters}
                    />
                </Flex>

                {!hasCollabPostsReporting && (
                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text className="-filter-title">
                            {t('filters.mvpScore')}
                        </Typography.Text>
                        <Select
                            placeholder={t('filters.selectMvpScore')}
                            options={mvpOptions}
                            value={values.mvpScore}
                            onChange={setFormValue('mvpScore')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={1}
                            maxTagPlaceholder={`...`}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                            }}
                            disabled={isOverridingFilters}
                        />
                    </Flex>
                )}
            </Flex>

            {hasCollabPostsReporting && (
                <Flex gap={16} wrap="wrap">
                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text
                            className="-filter-title"
                            data-test="authorship-type-dropdown"
                        >
                            {t('filters.authorshipType.label')}
                        </Typography.Text>
                        <Select
                            mode="multiple"
                            placeholder={t('filters.selectAuthorshipTypes')}
                            options={authorshipTypeOptions}
                            value={values.authorshipTypes ?? []}
                            onChange={setFormValue('authorshipTypes')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={1}
                            maxTagPlaceholder={`...`}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                            }}
                            autoClearSearchValue={false}
                            dropdownRender={dropdownWithSelectAll(() => {
                                setFormValue('authorshipTypes')(
                                    authorshipTypeOptions.map(
                                        ({ value }) => value,
                                    ),
                                );
                            }, authorshipTypeOptions.length > 0)}
                            disabled={isOverridingFilters}
                        />
                    </Flex>

                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text
                            className="-filter-title"
                            data-test="collaborating-accounts-input"
                        >
                            {t('filters.collaboratingAccounts')}
                        </Typography.Text>
                        <InputTag
                            value={values.collaboratingAccountUsernames ?? []}
                            onChange={setFormValue(
                                'collaboratingAccountUsernames',
                            )}
                            placeholderText={t(
                                'filters.enterCollaboratingAccounts',
                            )}
                            data-test="collaborating-accounts-input"
                            disabled={isOverridingFilters}
                            maxCount={100}
                            isHandleInput
                        />
                    </Flex>

                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text className="-filter-title">
                            {t('filters.mvpScore')}
                        </Typography.Text>
                        <Select
                            placeholder={t('filters.selectMvpScore')}
                            options={mvpOptions}
                            value={values.mvpScore}
                            onChange={setFormValue('mvpScore')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={1}
                            maxTagPlaceholder={`...`}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                            }}
                            disabled={isOverridingFilters}
                        />
                    </Flex>
                </Flex>
            )}
        </Flex>
    );
};

export default connect(['filters'])(SmpFiltersRow);
